import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { PlaylistVideo } from '@/store/playlist/types';
import { EpisodeList } from './EpisodeList';
import { ChevronUp } from 'lucide-react';
import { Drawer } from 'vaul';

interface EpisodeDrawerProps {
  videos: PlaylistVideo[];
  currentIndex: number;
  watchedEpisodes: Set<number>;
  onSelectEpisode: (index: number) => void;
  theme: 'purple' | 'blue' | 'dark' | 'white';
}

export const EpisodeDrawer: React.FC<EpisodeDrawerProps> = ({
  videos,
  currentIndex,
  watchedEpisodes,
  onSelectEpisode,
  theme
}) => {
  useLanguage();
  return (
    <div className="lg:hidden">
      <Drawer.Root>
        <Drawer.Trigger className="w-full p-4 bg-card border-t flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="font-semibold text-sm">{translateInterfaceText("Episódios (")}{videos.length})</span>
          </div>
          <ChevronUp className="w-5 h-5" />
        </Drawer.Trigger>
        
        <Drawer.Portal>
          <Drawer.Overlay className="fixed inset-0 bg-black/40 z-[9998]" />
          <Drawer.Content className="fixed bottom-0 left-0 right-0 max-h-[70vh] bg-card rounded-t-xl z-[9999] flex flex-col">
            <div className="flex-none p-4 border-b">
              <div className="w-12 h-1 bg-muted rounded-full mx-auto mb-4" />
              <h3 className="font-semibold text-base">{translateInterfaceText("Episódios")}</h3>
              <p className="text-sm text-muted-foreground mt-1">
                {videos.length} {" "}{translateInterfaceText("episódios")}</p>
            </div>
            
            <div className="flex-1 overflow-y-auto p-4">
              <EpisodeList 
                videos={videos}
                currentIndex={currentIndex}
                watchedEpisodes={watchedEpisodes}
                onSelectEpisode={onSelectEpisode}
                theme={theme}
              />
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
};
